import React from "react";
import { AiOutlineMail } from "react-icons/ai";
import { FaPhoneAlt } from "react-icons/fa";
import { ImFacebook2 } from "react-icons/im";
import { IoLogoYoutube } from "react-icons/io5";

import { ContactData } from "../data-types/api-client/api-contacts";
interface ContactProps {
  contact: ContactData | undefined; // Accept ContactData as a prop
}

const Header: React.FC<ContactProps> = ({ contact }) => {
  if (!contact) {
    return null; // Handle null contact state
  }
  return (
    <header
      className="hidden md:flex bg-bg-dark text-custom-gray text-md
 flex justify-between items-center font-roboto p-4 px-14"
    >
      <div className="flex items-center">
        <span
          className="mr-4 border-custom-mustard border-r-2 pr-4 py-2 group hover:cursor-pointer  
             transition duration-200 ease-in-out"
        >
          <a
            href={`mailto:${contact?.contact.email}`}
            className="flex items-center group-hover:text-custom-mustard-200"
          >
            <AiOutlineMail className="mr-2 text-3xl" />
            {contact?.contact.email}
          </a>
        </span>
        <span
          className="flex gap-4 group hover:cursor-pointer  
             transition duration-200 ease-in-out"
        >
          <a
            href={`tel:${contact?.contact.mobileConsultancy}`}
            className="
    flex
    flex-col
    gap-1
    items-center
    justify-center
    group-hover:text-custom-mustard-200
  "
          >
            <p
              className="
      text-xs
      text-[#F4B13D]
      tracking-widest
      uppercase
    "
            >
              Infolinka
            </p>

            <div
              className="
      flex
      items-center
      gap-2
      text-custom-white
      transition-colors
      duration-200
      group-hover:text-custom-mustard-200
    "
            >
              <FaPhoneAlt />

              <span className="text-center">
                {contact?.contact.mobileConsultancy}
              </span>
            </div>
          </a>
        </span>
      </div>
      {contact?.contact.facebookUrl && (
        <div className="flex items-center space-x-4 pr-3">
          <a
            href={`${contact?.contact.facebookUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-600"
          >
            <ImFacebook2 size={24} />
          </a>
          {contact?.contact.youtubeUrl && (
            <a
              href={`${contact?.contact.youtubeUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-red-600"
            >
              <IoLogoYoutube size={30} />
            </a>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
